import React, { useCallback, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Typography, Button } from '@mui/material';
import CountryManagementColum from './countryManagementColumn';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/loader';
import GenericDataGrid from '../../components/genericTable';
import { Icon } from "@iconify/react";
import { getAllcountryManagement } from './countryManagement.service';
import { createManagementTableSx } from '../../styles/tableStyles';
import { managementCreateButtonSx, managementHeaderActionSx, managementHeaderContentSx, managementHeaderSx, managementPageSubtitleSx, managementPageTitleSx } from '../../styles/managementStyles';
import AlertToast from '../../components/alertToast';
import { buttonContentSx } from '../../styles/dialogStyles';
import InlineAlert from '../../components/inlineAlert';

export default function SolutionManagementTable() {

  const navigate = useNavigate();
  const [countryListData, setCountryListData] = useState([]);

  const [errors, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [totalDataCount, setTotalDataCount] = useState("");
  const [currenntPagemain, setCurrentPagemain] = useState(0);
  const [rowsperpagemain, setrowsperpagemain] = useState(10);
  const [alert, setAlert] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');

  const alertClose = () => {
    setAlert('');
    setOpenAlert(false);
  };

  const getCountryData = useCallback(async (page = currenntPagemain, size = rowsperpagemain) => {
    setLoading(true);
    const res = await getAllcountryManagement(page, size);
    setLoading(false);

    if (res?.data?.content) {
      setCountryListData(res.data.content);
      setTotalDataCount(res.data.totalElements);
    } else {
      setCountryListData([]);
      setError("An error occurred while fetching data. Please try again later.");
    }
  }, [currenntPagemain, rowsperpagemain]);

  useEffect(() => {
    getCountryData(currenntPagemain, rowsperpagemain);
  }, [currenntPagemain, rowsperpagemain, getCountryData]);

  let countryData = {
    'limit': '',
    'page': '',
    'navigate': navigate,
    'getCountryData': getCountryData,
    'setAlert': setAlert,
    'setOpenAlert': setOpenAlert,
    'setResponseMsg': setResponseMsg,
    'setLoading': setLoading,
  }
  const countryManagementColumn = CountryManagementColum(countryData);
  const countryGridSx = createManagementTableSx();

  return (
    <>

      <Box sx={managementHeaderSx}>
        <Box sx={managementHeaderContentSx}>
          <Typography className="app-page-title" sx={managementPageTitleSx}>
            Country Management
          </Typography>
          <Typography sx={managementPageSubtitleSx}>
            Manage your country setup.
          </Typography>
        </Box>
        <Box sx={managementHeaderActionSx}>
          <Button
            variant="contained"
            type="submit"
            onClick={() => { setLoading(true); navigate('/countryManagementCreation') }}
            sx={{ ...managementCreateButtonSx, width: { xs: '100%', md: 'auto' }, minWidth: { xs: '100%', md: 204 } }}
          >
            <Box component="span" sx={buttonContentSx}>
              <Icon icon="tabler:plus" width="18" height="18" />
              <span>CREATE COUNTRY</span>
            </Box>
          </Button>
        </Box>
      </Box>

      <InlineAlert
        message={openAlert && alert === 'false' ? responseMsg : ''}
        onClose={alertClose}
        variant="error"
      />

      <Box sx={{ width: '100%', padding: '0 0px' }}>
        <GenericDataGrid rows={countryListData} columns={countryManagementColumn} rowCount={totalDataCount} page={currenntPagemain} pageSize={rowsperpagemain} loading={loading} errors={errors} checkbox='false'
          dataGridSx={countryGridSx}
          tableMinWidth={1080}
          rowHeight={60}
          onPaginationChange={(page, pageSize) => {
            setCurrentPagemain(page);
            setrowsperpagemain(pageSize);
            getCountryData(page, pageSize);
          }}
        />
      </Box>
      {loading && <Loader />}

      <Box textAlign={'end'}>
        <AlertToast open={openAlert && alert === 'true'} onClose={alertClose} message={responseMsg} variant="success" />
      </Box>

    </>
  );
}
